import { a as h } from "./chunk-BaseElement-CJM6sCUz.js";
import { W as c } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { t as l } from "./chunk-custom-element-CN0MC8o7.js";
import { n as u } from "./chunk-property---aaewZr.js";
var p = Object.defineProperty, g = Object.getOwnPropertyDescriptor, d = (t, e, i, s) => {
  for (var r = s > 1 ? void 0 : s ? g(e, i) : e, n = t.length - 1, a; n >= 0; n--)
    (a = t[n]) && (r = (s ? a(e, i, r) : a(r)) || r);
  return s && r && p(e, i, r), r;
};
const _ = "_collection_grid_size";
let o = class extends c(
  h
) {
  constructor() {
    super(), this._handleChange = this._handleChange.bind(this);
  }
  firstUpdated() {
    this.radioButtons = this.querySelectorAll(
      'input[type="radio"]'
    ), this.grid = document.querySelector(this.gridTarget), this.initListeners();
  }
  disconnectedCallback() {
    this.radioButtons.forEach((t) => {
      t.removeEventListener("change", this._handleChange);
    });
  }
  initListeners() {
    this.radioButtons.forEach((t) => {
      t.addEventListener("change", this._handleChange);
    });
  }
  _handleChange(t) {
    const e = t.target, { value: i } = e;
    document.startViewTransition ? document.startViewTransition(() => {
      this.setGridSizeAttribute(i);
    }) : this.setGridSizeAttribute(i), document.dispatchEvent(new CustomEvent("tabSliderUpdate")), this.updateCartNoteAndAttributes(
      {
        attributes: {
          [_]: i
        }
      },
      {
        sections: !0
      }
    );
  }
  setGridSizeAttribute(t) {
    var e;
    (e = this.grid) == null || e.setAttribute(
      "data-expanded",
      t === "single" ? "true" : "false"
    );
  }
};
d([
  u({ type: String, attribute: "grid-target" })
], o.prototype, "gridTarget", 2);
o = d([
  l("grid-size-select")
], o);
export {
  o as GridSizeSelect
};
